import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { ResultProc } from '@app/models/system/result-proc.model';

@Injectable({
  providedIn: 'root'
})
export class PdtDetailService {

  constructor(private _http: HttpClient) { }

  loadPdtDetail(pdtCd: string, userid: string): Observable<PdtDetailModel> {
    let url = `${environment.apiUrl}/product/info?comId=${environment.comId}&pdtCd=${pdtCd}&userid=${userid}`;
    return this._http.get<PdtDetailModel>(url);
  }

  loadPdtImages(pdtCd: string, pathKind: string): Observable<PdtDetailModel[]> {
    let url = `${environment.apiUrl}/product/info-image?comId=${environment.comId}&pdtCd=${pdtCd}&pathKind=${pathKind}`;
    return this._http.get<PdtDetailModel[]>(url);
  }

  loadPdtNotify(pdtCd: string): Observable<PdtDetailModel[]> {
    let url = `${environment.apiUrl}/product/info-notify?comId=${environment.comId}&pdtCd=${pdtCd}`;
    return this._http.get<PdtDetailModel[]>(url);
  }
  getPdtInfosByCateCd(cateCd: string, rowNum: string, prdCd:string, pathKind:string): Observable<PdtDetailModel[]> {
    let url = `${environment.apiUrl}/product/products-related?comId=${environment.comId}&pdtCd=${prdCd}&rowNum=${rowNum}&cateCd=${cateCd}&pathKind=${pathKind}`;
    return this._http.get<PdtDetailModel[]>(url);
  }

  getPdtReview(pdtCd: string , orderBy:string, page:number, len:number): Observable<PdtDetailModel[]> {
    let url = `${environment.apiUrl}/product/reviewPdt?comId=${environment.comId}&pdtCd=${pdtCd}&orderBy=${orderBy}&page=${page}&len=${len}`;
    return this._http.get<PdtDetailModel[]>(url);
  }

  getPdtReviewCount(pdtCd: string): Observable<Number> {
    let url = `${environment.apiUrl}/product/reviewPdtCount?comId=${environment.comId}&pdtCd=${pdtCd}`;
    return this._http.get<Number>(url);
  }

  savePdtReviews(params: any): Observable<ResultProc>{
    let url = `${environment.apiUrl}/product/reviewPdt/save`;
    return this._http.post<ResultProc>(url, params);
  }

  checkReviewPdt(userid: string, pdtCd: string): Observable<Number> {
    let url = `${environment.apiUrl}/product/check-ReviewPdt?comId=${environment.comId}&userid=${userid}&pdtCd=${pdtCd}`;
    return this._http.get<Number>(url);
  }

  getGradeOfProducts(pdtCd: string): Observable<PdtDetailModel[]> {
    let url = `${environment.apiUrl}/product/reviewPdt/grades?comId=${environment.comId}&pdtCd=${pdtCd}`;
    return this._http.get<PdtDetailModel[]>(url);
  }
}